import React from "react"
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom"

import "./App.scss"

import { AuthenticationProvider } from "./context/AuthenticationContext"
import { BackButtonProvider } from "./context/BackButtonContext"
import { QuestionnaireProvider } from "./context/QuestionnaireContext"

import { AppointmentPage } from "./pages/appointment/AppointmentPage"
import { AppointmentSummary } from "./pages/appointmentSummary/AppointmentSummary"
import { ErrorPage } from "./pages/error/ErrorPage"
import { NoQuestionnaire } from "./pages/questionnaire/NoQuestionnaire"
import { QuestionPage } from "./pages/questionnaire/QuestionPage"
import { QuestionnaireStart } from "./pages/questionnaire/QuestionnaireStart"
import { QuestionnaireSummary } from "./pages/questionnaire/QuestionnaireSummary"
import { QuestionnaireComplete } from "./pages/questionnaire/QuestionnaireComplete"

function AppRouter(): JSX.Element {
  const router = createBrowserRouter([
    {
      element: (
        <BackButtonProvider>
          <AuthenticationProvider>
            <QuestionnaireProvider>
              <Outlet />
            </QuestionnaireProvider>
          </AuthenticationProvider>
        </BackButtonProvider>
      ),
      children: [
        {
          path: "/",
          element: <ErrorPage />,
          errorElement: <ErrorPage />,
        },
        {
          path: "/error",
          element: <ErrorPage />,
        },
        {
          path: "appointment/:odsId/:appointmentId",
          element: <AppointmentPage />,
          children: [
            { index: true, element: <AppointmentSummary /> },
            {
              path: ":patientAction/:questionnaireId/page/:pageId",
              element: <QuestionPage />,
            },
            {
              path: ":patientAction/:questionnaireId/summary",
              element: <QuestionnaireSummary />,
            },
            {
              path: ":patientAction/:questionnaireId/complete",
              element: <QuestionnaireComplete />,
            },
            {
              path: ":patientAction/:questionnaireId",
              element: <QuestionnaireStart />,
            },
            {
              path: ":patientAction",
              element: <NoQuestionnaire />,
            },
          ],
        },
      ],
    },
  ])

  return (
    <div className="app">
      <React.StrictMode>
        <RouterProvider router={router} />
      </React.StrictMode>
    </div>
  )
}

export default AppRouter
